import { startsWith, map, keyBy, without, omit } from 'lodash'

export const isWantAction = ({ type }) =>
  startsWith(type, 'I_WANT') || startsWith(type, 'I_WANT_NOT')

export const isSwapAction = ({ type }) => startsWith(type, 'SWAP_ACTION')

export const removeOwner = (obj, userId) => {
  if (!obj.posseduto_da || !obj.posseduto_da.length) {
    return obj
  }
  return {
    ...obj,
    posseduto_da: obj.posseduto_da.filter(owner => +owner.user.id !== +userId),
  }
}

export const normalizeCollection = (collection, byKey = 'id') => ({
  ids: map(collection, byKey),
  data: keyBy(collection, byKey),
})

export const swapRemoveItem = (items, item) => ({
  data: omit(items.data, item.id),
  ids: without(items.ids, item.id),
})

export const swapAddItem = (items, item) => ({
  data: {
    ...items.data,
    [item.id]: item,
  },
  ids: items.ids.concat(item.id),
})

export const swapEdit = (typePrefix, reducer) => {
  const swapEditReducer = (prevState, { payload, type }) => {
    switch (type) {
      case `${typePrefix}_ADD_ITEM_PROPONENTE`:
        return {
          ...prevState,
          swap: {
            ...prevState.swap,
            proponenteItems: swapAddItem(
              prevState.swap.proponenteItems,
              payload
            ),
          },
        }
      case `${typePrefix}_ADD_ITEM_DESTINATARIO`:
        return {
          ...prevState,
          swap: {
            ...prevState.swap,
            destinatarioItems: swapAddItem(
              prevState.swap.destinatarioItems,
              payload
            ),
          },
        }
      case `${typePrefix}_REMOVE_ITEM_PROPONENTE`:
        return {
          ...prevState,
          swap: {
            ...prevState.swap,
            proponenteItems: swapRemoveItem(
              prevState.swap.proponenteItems,
              payload
            ),
          },
        }
      case `${typePrefix}_REMOVE_ITEM_DESTINATARIO`:
        return {
          ...prevState,
          swap: {
            ...prevState.swap,
            destinatarioItems: swapRemoveItem(
              prevState.swap.destinatarioItems,
              payload
            ),
          },
        }
      case `${typePrefix}_SET_MONEY_PROPONENTE`:
        return {
          ...prevState,
          swap: {
            ...prevState.swap,
            proponenteMoney: payload,
          },
        }
      case `${typePrefix}_SET_MONEY_DESTINATARIO`:
        return {
          ...prevState,
          swap: {
            ...prevState.swap,
            destinatarioMoney: payload,
          },
        }
      default:
        return prevState
    }
  }

  return (prevState, action) =>
    reducer(swapEditReducer(prevState, action), action)
}



// WEBPACK FOOTER //
// ./src/reducers/helpers.js